import React from 'react';
import { useTranslation } from 'react-i18next';
import { SuggestedProcess } from '../types';

interface SuggestedProcessesCardProps {
    processes: SuggestedProcess[];
    onProcessSelect?: (process: SuggestedProcess) => void;
}

const SuggestedProcessesCard: React.FC<SuggestedProcessesCardProps> = ({
    processes,
    onProcessSelect,
}) => {
    const { t } = useTranslation();

    if (!processes || processes.length === 0) {
        return null;
    }

    return (
        <div className="card border-0 shadow-sm mt-3 mb-3" style={{ backgroundColor: 'rgba(255,255,255,0.05)' }}>
            <div className="card-body">
                <h6 className="card-title mb-3 text-light fw-bold">
                    <i className="bi bi-lightbulb me-2 text-warning"></i>
                    {t('campaigns.suggestedProcesses') || 'Processus suggérés par l\'IA'}
                </h6>
                <div className="d-flex flex-column gap-2">
                    {processes.map((process, index) => (
                        <div
                            key={index}
                            className="p-3 rounded"
                            style={{
                                backgroundColor: 'rgba(108, 117, 125, 0.2)',
                                border: '1px solid rgba(255,255,255,0.1)',
                                cursor: onProcessSelect ? 'pointer' : 'default',
                            }}
                            onClick={() => onProcessSelect?.(process)}
                        >
                            <div className="d-flex align-items-start mb-2">
                                <i className="bi bi-diagram-3 me-2 text-info mt-1"></i>
                                <div className="flex-grow-1">
                                    <h6 className="mb-1 text-light fw-semibold">{process.title}</h6>
                                    <p className="text-secondary small mb-1">{process.description}</p>
                                    {process.reason && (
                                        <p className="text-info small mb-0">
                                            <i className="bi bi-info-circle me-1"></i>
                                            <em>{process.reason}</em>
                                        </p>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="mt-3 pt-2 border-top border-secondary">
                    <p className="text-secondary small mb-0">
                        <i className="bi bi-chat-dots me-1"></i>
                        {t('campaigns.confirmOrModifyProcesses') || 'Vous pouvez confirmer ou modifier cette liste dans le chat'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default SuggestedProcessesCard;

